import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import { LOGO_SCHOOL } from "./../../Constants/SrcImages";
import moment from "moment";
import { PaginationHeaderYear } from "./../../Constants/Util";
import { Row, Col, Container, Nav, NavItem, NavLink, TabPane, TabContent, FormGroup, Form, Input, Label, Button } from "reactstrap";
import classnames from "classnames";
import { ModalListaPerson } from "./../../Constants/Modal";
import REACT_PRINT_COMPONENT from "./../../Constants/React_print";
import { IPersonSelect } from "./../../Constants/Interfaces";
import { getPersonByCedulaRPago, getReportDiary, getReportMonth, getReportPerson, getPersonList } from "../../Constants/Services";

interface IReportDiary {
  rp_secuencia: string;
  per_name: string;
  per_cedula: string;
  rpd_monto: string;
  rp_metodo_pago: string;
  rpm_desc: string;
  rp_referencia: string;
  rpd_secuencia:string;
}

interface IReportMonth {
  rp_date: string;
  rpd_monto: string;
}

interface IReportDiaryTpago {
  rpd_rpago: string;
  tp_desc: string;
  rpd_secuencia:string;
}

interface IReportPersonTpago {
  rpd_id: string;
  rpd_rpago: string;
  tp_desc: string;
  rpd_secuencia:string;
}

interface IReportPerson {
  rp_secuencia: string;
  rp_date: string;
  rpd_monto: string;
  rpm_desc: string;
  rp_referencia:string;
}

interface IInformeState {
  dataPerson: IPersonSelect[];
  dataPersonForm: IPersonSelect;
  year: string;
  dateIDairy: string;
  dataReportMonth: IReportMonth[];
  dateIMensual: string;
  activeTab: string;
  dataReportDiary: IReportDiary[];
  dateSelected: boolean;
  msg_error: string;
  isOpenModalLista: boolean;
  dataReportDiaryTpago: IReportDiaryTpago[];
  dataReportPerson: IReportPerson[];
  dataReportPersonTpago: IReportPersonTpago[];
  stateSearchPerson: boolean;
  stateSearchMonth: boolean;
  stateSearchDiary: boolean;
}

class Informes extends Component<RouteComponentProps<{}>, IInformeState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataReportDiary: [],
      dataReportPerson: [],
      dataReportPersonTpago: [],
      dataReportMonth: [],
      year: new Date().getFullYear().toString(),
      dateIDairy: new Date().toString(),
      dataPerson: [],
      dataReportDiaryTpago: [],
      dataPersonForm: {
        per_id: "",
        per_name: "",
        per_cedula: "",
      },
      dateIMensual: "",
      activeTab: "1",
      dateSelected: false,
      msg_error: "",
      isOpenModalLista: false,
      stateSearchPerson: true,
      stateSearchMonth: true,
      stateSearchDiary: true,
    };
    this.fetchReportDiary = this.fetchReportDiary.bind(this);
    this.onChangeDatePickerDairy = this.onChangeDatePickerDairy.bind(this);
    this.handlerActiveTab = this.handlerActiveTab.bind(this);
    this.changeHeader = this.changeHeader.bind(this);
    this.onChangeDatePickerMonth = this.onChangeDatePickerMonth.bind(this);
    this.fetchReportMonth = this.fetchReportMonth.bind(this);
    this.onChangeForm = this.onChangeForm.bind(this);
    this.handlerOpenLista = this.handlerOpenLista.bind(this);
    this.handlerSearchPerson = this.handlerSearchPerson.bind(this);
    this.setPerson = this.setPerson.bind(this);
    this.handlerSetPerson = this.handlerSetPerson.bind(this);
    this.fetchReportByPerson = this.fetchReportByPerson.bind(this);
    this.fetchPersonList = this.fetchPersonList.bind(this);
    this.handlerCleanSearch = this.handlerCleanSearch.bind(this);
  }

  async fetchReportByPerson() {
    const props = this.state;
    const response = await getReportPerson(props.year, props.dataPersonForm.per_id);
    this.setState({
      dataReportPerson: response.total,
      dataReportPersonTpago: response.detail,
      stateSearchPerson: false,
    });
    this.iDiaryBody();
  }

  async fetchPersonList() {
    const response = await getPersonList();
    this.setState({
      dataPerson: response,
    });
  }

  handlerCleanSearch() {
    this.setState({
      dataReportDiary: [],
      dataReportPersonTpago: [],
      dataReportPerson: [],
      dataReportDiaryTpago: [],
      dataReportMonth: [],
      stateSearchPerson: true,
      stateSearchMonth: true,
      stateSearchDiary: true,
      dataPersonForm: {
        per_id: "",
        per_name: "",
        per_cedula: "",
      },
    });
  }
  
  handlerSetPerson(row: any) {
    this.setState({
      dataPersonForm: {
        ...this.state.dataPersonForm,
        per_id: row.per_id,
        per_cedula: row.per_cedula,
        per_name: row.per_name,
      },
      isOpenModalLista: false,
    });
  }

  setPerson(cell, row) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Button className="txt-underline w-100" onClick={() => this.handlerSetPerson(row)}>
            Selecionar
          </Button>
        </Col>
      </Row>
    );
  }

  changeHeader({ year, operation }: any) {
    var currentYear = new Date();

    var result = year;
    if (operation === "left") result = parseInt(year) - 1;
    else {
      result = parseInt(year) + 1;
      if (result > currentYear.getFullYear()) result = currentYear.getFullYear();
    }
    this.setState({
      year: result,
    });
  }

  handlerOpenLista() {
    this.setState((prevState) => ({
      isOpenModalLista: !prevState.isOpenModalLista,
    }));
  }

  async handlerSearchPerson() {
    const props = this.state.dataPersonForm;
    if (props.per_cedula.length > 0) {
      const response = await getPersonByCedulaRPago(props.per_cedula);
      if (response.existe !== "no") {
        this.setState({
          dataPersonForm: {
            ...this.state.dataPersonForm,
            per_id: response[0].per_id,
            per_cedula: response[0].per_cedula,
            per_name: response[0].per_name + ` ` + response[0].per_lastname,
          },
          msg_error: "",
        });
        this.fetchReportByPerson();
      } else {
        this.setState({
          msg_error: "No existe persona con esa cedula",
        });
      }
    } else {
      this.setState({
        msg_error: "El campo cedula esta vacio",
      });
    }
  }

  async fetchReportDiary() {
    const props = this.state.dateIDairy;
    const response = await getReportDiary(moment(props).format("YYYY-MM-DD"));
    this.setState({
      dataReportDiary: response.total,
      dataReportDiaryTpago: response.detail,
      stateSearchDiary: false,
    });
    this.iDiaryBody();
  }

  async fetchReportMonth() {
    const props = this.state.dateIDairy;
    const response = await getReportMonth(moment(props).format("YYYY"), moment(props).format("MM"));
    this.setState({
      dataReportMonth: response,
      stateSearchMonth: false,
    });
    this.iDiaryBody();
  }

  componentDidMount() {
    this.fetchPersonList();
  }

  onChangeDatePickerMonth(date: any) {
    const props = this.state.activeTab;
    this.setState({
      dateIDairy: date,
      dateSelected: true,
    });
    if (props === "1") {
      setTimeout(() => {
        this.fetchReportDiary();
      }, 1000);
    } else if (props === "2") {
      setTimeout(() => {
        this.fetchReportMonth();
      }, 1000);
    } else {
      setTimeout(() => {
        this.fetchReportByPerson();
      }, 1000);
    }
  }

  onChangeDatePickerDairy(date: any) {
    this.setState({
      dateIDairy: date,
      dateSelected: true,
    });
    setTimeout(() => {
      this.fetchReportDiary();
    }, 1000);
  }

  handlerActiveTab(id: string) {
    this.setState({
      activeTab: id,
      dateIDairy: new Date().toString(),
      dataReportDiary: [],
      dataReportPersonTpago: [],
      dataReportPerson: [],
      dataReportDiaryTpago: [],
      dataReportMonth: [],
      stateSearchPerson: true,
      stateSearchMonth: true,
      stateSearchDiary: true,
      dataPersonForm: {
        per_id: "",
        per_name: "",
        per_cedula: "",
      },
    });
  }

  iPersonBody = () => {
    const props = this.state;
    var tl_diario = 0;

    return (
      <React.Fragment>
        <Row className="mt-5" key={new Date().toString()}>
          <Col xs={12} className="text-center">
            <img alt="" className="logo-school-informe" src={LOGO_SCHOOL}></img>
            <h4 className="font-weight-bold h4-prelative">
              The King's School David <br></br>
              <br></br>
              INFORME POR PERSONA
            </h4>
          </Col>
          <Col xs={12} className="text-left mb-3">
            {/* <Label className="font-weight-bold">Fecha : {moment(new Date(props.dateIDairy)).format("YYYY-MM-DD")}</Label> <br></br> */}
            <Label className="font-weight-bold">Nombre : {props.dataPersonForm.per_name}</Label> <br></br>
            <Label className="font-weight-bold">Cedula : {props.dataPersonForm.per_cedula}</Label> <br></br>
            <Label className="font-weight-bold">Periodo : {props.year}</Label> <br></br>
            <Label className="font-weight-bold">Fecha de Impresion: {moment(new Date()).format("YYYY-MM-DD")}</Label>
          </Col>
          <Col xs={12} className="text-center">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-center">Fecha</th>
                  <th className="text-center">Tipo de pago</th>
                  <th className="text-center">Metodo</th>
                  <th className="text-center">Referencia</th>
                  <th className="text-center">Monto</th>
                </tr>
              </thead>
              <tbody>
                {props.dataReportPerson.map((data, i) => {
                  tl_diario = Number(tl_diario) + Number(data.rpd_monto);

                  return (
                    <tr key={i}>
                      <td className="text-center">{data.rp_date}</td>
                      <td className="text-center">
                        (
                        {props.dataReportPersonTpago.map((dataTpago, i) => {
                          // if (dataTpago.rp_secuencia === data.rp_secuencia) {
                          //   return dataTpago.tp_desc + " ";
                          // }
                          return null;
                        })}
                        )
                      </td>
                      <td className="text-center">{data.rpm_desc}</td>
                      <td className="text-center">{data.rp_referencia}</td>
                      <td className="text-right">{data.rpd_monto}</td>
                    </tr>
                  );
                })}

                <tr>
                  <td className=""></td>
                  <td className=""></td>
                  <td>
                    <Label className="font-weight-bold">TOTALES</Label>
                  </td>
                  <td className="text-right font-weight-bold">{tl_diario.toFixed(2)}</td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col xs={12} className="text-left mt-3">
            <Label className="font-weight-bold">Revisador por : _________________________________________________</Label>
          </Col>
        </Row>
      </React.Fragment>
    );
  };
  iDiaryBody = () => {
    const props = this.state;
    var tl_diario = 0;
    var tl_ach = 0;
    var tl_deposito = 0;
    var tl_efectivo = 0;
    var tl_tarjeta = 0;
    var tl_bono = 0;

    return props.dateSelected ? (
      <React.Fragment>
        <Row className="mt-5 px-5">
          <Col xs={12} className="text-center">
            <img alt="" className="logo-school-informe" src={LOGO_SCHOOL}></img>
            <h4 className="font-weight-bold h4-prelative">
              The King's School David <br></br>
              <br></br>
              INFORME DIARIO
            </h4>
          </Col>
          <Col xs={12} className="text-left mb-3">
            <Label className="font-weight-bold">Fecha : {moment(props.dateIDairy).format("YYYY-MM-DD")}</Label>
          </Col>
          <Col xs={12} className="text-left mb-3">
            <Label className="font-weight-bold">Fecha de Impresion: {moment(new Date()).format("YYYY-MM-DD")}</Label>
          </Col>
          <Col xs={12} className="text-center">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-center">Cliente</th>
                  <th className="text-center">Descripcion</th>
                  <th className="text-center">ACH</th>
                  <th className="text-center">Deposito</th>
                  <th className="text-center">Efectivo</th>
                  <th className="text-center">Tarjeta</th>
                  <th className="text-center">Bono</th>
                  <th className="text-center">Referencia</th>
                </tr>
              </thead>
              <tbody>
                {props.dataReportDiary.map((data, i) => {
                  tl_diario = Number(tl_diario) + Number(data.rpd_monto);
                  if (data.rp_metodo_pago === "1") tl_ach = Number(tl_ach) + Number(data.rpd_monto);
                  if (data.rp_metodo_pago === "2") tl_deposito = Number(tl_deposito) + Number(data.rpd_monto);
                  if (data.rp_metodo_pago === "3") tl_efectivo = Number(tl_efectivo) + Number(data.rpd_monto);
                  if (data.rp_metodo_pago === "4") tl_tarjeta = Number(tl_tarjeta) + Number(data.rpd_monto);
                  if (data.rp_metodo_pago === "5") tl_bono = Number(tl_bono) + Number(data.rpd_monto);

                  return (
                    <tr key={data.rp_secuencia}>
                      <td>
                        {data.per_name} {data.per_cedula}
                      </td>
                      <td>
                        (
                        {props.dataReportDiaryTpago.map((dataTpago, i) => {
                          if (dataTpago.rpd_secuencia === data.rp_secuencia) {
                            return dataTpago.tp_desc + " ";
                          }
                          return null;
                        })}
                        )
                      </td>
                      <td className="text-right">{data.rp_metodo_pago === "1" ? data.rpd_monto : null}</td>
                      <td className="text-right">{data.rp_metodo_pago === "2" ? data.rpd_monto : null}</td>
                      <td className="text-right">{data.rp_metodo_pago === "3" ? data.rpd_monto : null}</td>
                      <td className="text-right">{data.rp_metodo_pago === "4" ? data.rpd_monto : null}</td>
                      <td className="text-right">{data.rp_metodo_pago === "5" ? data.rpd_monto : null}</td>
                      <td className="text-right">{data.rp_referencia}</td>
                    </tr>
                  );
                })}

                <tr>
                  <td>
                    <Label className="font-weight-bold">TOTALES</Label>
                  </td>
                  <td></td>
                  <td className="text-right font-weight-bold">{tl_ach.toFixed(2)}</td>
                  <td className="text-right font-weight-bold">{tl_deposito.toFixed(2)}</td>
                  <td className="text-right font-weight-bold">{tl_efectivo.toFixed(2)}</td>
                  <td className="text-right font-weight-bold">{tl_tarjeta.toFixed(2)}</td>
                  <td className="text-right font-weight-bold">{tl_bono.toFixed(2)}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col xs={8} className="text-left mt-3">
            <Label className="font-weight-bold">Revisador por : _________________________________________________</Label>
          </Col>
          <Col xs={2} className="text-right mt-3">
            <Label for="name" className="font-weight-bold label-totaldiario">
              Total Diario:{" "}
            </Label>
          </Col>
          <Col xs={2} className="text-left mt-3">
            <Form>
              <FormGroup>
                <Input
                  type="text"
                  name="tl_diario"
                  className="text-right font-weight-bold"
                  value={tl_diario.toFixed(2)}
                  id="tl_diario"
                  placeholder="Total Diario"
                  disabled
                />
              </FormGroup>
            </Form>
          </Col>
        </Row>
      </React.Fragment>
    ) : null;
  };
  iMonthBody = () => {
    const props = this.state;
    var tl_month = 0;

    return props.dateSelected ? (
      <React.Fragment>
        <Row className="mt-5 px-5">
          <Col xs={12} className="text-center">
            <img alt="" className="logo-school-informe" src={LOGO_SCHOOL}></img>
            <h4 className="font-weight-bold h4-prelative">
              The King's School David <br></br>
              <br></br>
              INFORME MENSUAL
            </h4>
          </Col>
          <Col xs={12} className="text-left mb-3">
            <Label className="font-weight-bold">Fecha : {moment(props.dateIDairy).format("MMMM YYYY")}</Label>
          </Col>
          <Col xs={12} className="text-left mb-3">
            <Label className="font-weight-bold">Fecha de Impresion: {moment(new Date()).format("YYYY-MM-DD")}</Label>
          </Col>
          <Col xs={12} className="text-center">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th className="text-center">Fecha</th>
                  <th className="text-center">Monto</th>
                </tr>
              </thead>
              <tbody>
                {props.dataReportMonth.map((data, i) => {
                  tl_month = Number(tl_month) + Number(data.rpd_monto);

                  return (
                    <tr key={i}>
                      <td>{data.rp_date}</td>
                      <td className="text-right">{data.rpd_monto}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Col>
          <Col xs={8} className="text-left mt-3">
            <Label className="font-weight-bold">Revisador por : _________________________________________________</Label>
          </Col>
          <Col xs={2} className="text-right mt-3">
            <Label for="name" className="font-weight-bold label-totaldiario">
              Bruto por mes:{" "}
            </Label>
          </Col>
          <Col xs={2} className="text-left mt-3">
            <Form>
              <FormGroup>
                <Input
                  type="text"
                  name="tl_month"
                  className="text-right font-weight-bold"
                  value={tl_month.toFixed(2)}
                  id="tl_month"
                  placeholder="Bruto por mes"
                  disabled
                />
              </FormGroup>
            </Form>
          </Col>
        </Row>
      </React.Fragment>
    ) : null;
  };

  onChangeForm(e: any) {
    this.setState({
      dataPersonForm: {
        ...this.state.dataPersonForm,
        [e.target.name]: e.target.value,
      },
    });
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalLista && (
          <ModalListaPerson
            dataPerson={props.dataPerson}
            setPerson={this.setPerson}
            toggleClose={this.handlerOpenLista}
            isOpen={props.isOpenModalLista}
            title="Selecionar persona"
          />
        )}
        <Container className="mt-4">
          <Row>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === "1" })}
                  onClick={() => {
                    this.handlerActiveTab("1");
                  }}
                >
                  Ingresos Diarios
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === "2" })}
                  onClick={() => {
                    this.handlerActiveTab("2");
                  }}
                >
                  Ingresos Mensuales
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === "3" })}
                  onClick={() => {
                    this.handlerActiveTab("3");
                  }}
                >
                  Ingresos por Persona
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={props.activeTab} className="w-100">
              <TabPane tabId="1">
                <Row>
                  <Col className="text-center mt-4 mb-2">
                    <h4>Informe Diario</h4>
                  </Col>
                  <Col sm={12}>
                    {props.stateSearchDiary ? (
                      <React.Fragment>
                        {" "}
                        <FormGroup>
                          <Label className="font-weight-bold">Seleccionar la Fecha:</Label>
                          <br></br>
                          <DatePicker
                            selected={new Date(props.dateIDairy)}
                            onChange={this.onChangeDatePickerDairy}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            className="form-control w-100"
                          />
                        </FormGroup>
                      </React.Fragment>
                    ) : (
                      <Button color="danger" className="mr-2 button-pr" onClick={() => this.handlerCleanSearch()}>
                        Buscar de nuevo
                      </Button>
                    )}
                  </Col>
                  <Col xs={12} className="mt-5">
                    {props.dataReportDiary.length > 0 ? (
                      <REACT_PRINT_COMPONENT body={this.iDiaryBody()} />
                    ) : (
                      <Row>
                        <Col xs={12} className="text-center">
                          <Label className="font-weight-bold result-none">Sin Resultados</Label>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">
                <Row>
                  <Col className="text-center mt-4 mb-2">
                    <h4>Informe Mensual</h4>
                  </Col>
                  <Col sm={12}>
                    {props.stateSearchMonth ? (
                      <React.Fragment>
                        {" "}
                        <FormGroup>
                          <Label className="font-weight-bold">Seleccionar el mes:</Label>
                          <br></br>
                          <DatePicker
                            selected={new Date(props.dateIDairy)}
                            onChange={this.onChangeDatePickerMonth}
                            dateFormat="MM/yyyy"
                            showMonthYearPicker
                            showFullMonthYearPicker
                            dropdownMode="select"
                            className="form-control w-100"
                          />
                        </FormGroup>
                      </React.Fragment>
                    ) : (
                      <Button color="danger" className="mr-2 button-pr" onClick={() => this.handlerCleanSearch()}>
                        Buscar de nuevo
                      </Button>
                    )}
                  </Col>
                  <Col sm={12} className="mt-5">
                    {props.dataReportMonth.length > 0 ? (
                      <REACT_PRINT_COMPONENT body={this.iMonthBody()} />
                    ) : (
                      <Row>
                        <Col xs={12} className="text-center">
                          <Label className="font-weight-bold result-none">Sin Resultados</Label>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="3">
                <Row>
                  <Col sm={12} className="text-center mb-3">
                    <PaginationHeaderYear year={props.year} changeHeader={this.changeHeader} />
                  </Col>
                </Row>
                <Row>
                  <Col className="text-center mt-4 mb-2">
                    <h4>Informe por persona</h4>
                  </Col>
                  <Col sm={4}>
                    <FormGroup>
                      <Label className="font-weight-bold">Cliente : </Label>
                      <Input
                        type="text"
                        name="per_cedula"
                        onChange={this.onChangeForm}
                        value={props.dataPersonForm.per_cedula}
                        id="per_cedula"
                        placeholder="Cedula"
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={4}>
                    {props.stateSearchPerson ? (
                      <React.Fragment>
                        <Button color="success" className="mr-2 button-pr" onClick={() => this.handlerSearchPerson()}>
                          Buscar
                        </Button>
                        <Button color="info" className="mr-2 button-pr" onClick={() => this.handlerOpenLista()}>
                          Lista
                        </Button>
                      </React.Fragment>
                    ) : (
                      <Button color="danger" className="mr-2 button-pr" onClick={() => this.handlerCleanSearch()}>
                        Buscar de nuevo
                      </Button>
                    )}
                  </Col>
                  <Col sm={4}></Col>
                  <Col sm={12} className="text-left h-40px">
                    {props.msg_error.length > 0 ? (
                      <Label className="font-weight-bold  l-color-danger">{props.msg_error}</Label>
                    ) : props.dataPersonForm.per_name.length > 0 ? (
                      <Label className="font-weight-bold">{`Nombre : ${props.dataPersonForm.per_name}    Cedula:  ${props.dataPersonForm.per_cedula}`}</Label>
                    ) : null}
                  </Col>
                  <Col xs={12}>
                    {props.dataReportPerson.length > 0 ? (
                      <REACT_PRINT_COMPONENT body={this.iPersonBody()} />
                    ) : (
                      <Row>
                        <Col xs={12} className="text-center">
                          <Label className="font-weight-bold result-none">Sin Resultados</Label>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default Informes;
